import CountryIcon from '@material-ui/icons/TurnedIn';
import CountryList from './CountryList';
import CountryCreate from './CountryCreate';
import CountryEdit from './CountryEdit';
const CountryModule = {
    list: CountryList,
    icon: CountryIcon,
    create: CountryCreate,
    edit: CountryEdit,
}; export default CountryModule;